/* Sends the correct goggles variant to the cart.
   The offer block was written before the tier existed and always added the
   standard variant, so a 3-mask order would have shown $14.95 on the tile and
   charged $19.95. This intercepts the add and swaps the id when three masks
   are selected. It runs before the offer block's own handler. */
(function(){
var IDS=window.IF_ADDON_IDS||{};
if(!IDS.goggles||!IDS.gogglesBundle)return;

var orig=window.fetch;
window.fetch=function(){
var url=arguments[0];
var u=(typeof url==='string')?url:(url&&url.url)||'';
if(u.indexOf('/cart/add')>-1&&arguments[1]&&arguments[1].body){
try{
var body=JSON.parse(arguments[1].body);
if(body&&body.items&&body.items.length){
var units=document.getElementById('if-units');
var masks=units?units.children.length:1;
var wanted=masks>=3?IDS.gogglesBundle:IDS.goggles;
var other=masks>=3?IDS.goggles:IDS.gogglesBundle;
var changed=false;
body.items.forEach(function(it){
if(it.id===other){it.id=wanted;changed=true;}
});
if(changed)arguments[1].body=JSON.stringify(body);
}
}catch(e){}
}
return orig.apply(this,arguments);
};
})();
